import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Component, ElementRef, EventEmitter, Input, Output } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { map } from "rxjs/operators";
import { CardButtonType } from "../types/card-button.type";

type View = "mobile" | "desktop";

@Component({
  selector: "ds-card-button",
  templateUrl: "./ds-card-button.component.html",
  styleUrls: ["./ds-card-button.component.scss"],
})
export class DsCardButtonComponent {
  @Input() icon: string = "";
  @Input() dsIcon: string = "";
  @Input() type: CardButtonType = "neutral";
  @Input() label: string = "";
  @Input() labelButton: string = "";
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() loadingText: string = "Cargando";
  @Output() onClick: EventEmitter<void> = new EventEmitter<void>();

  readonly sizeMap: Record<View, "sm" | "md"> = {
    mobile: "sm",
    desktop: "md",
  };

  private destroy$ = new Subject<void>();

  isMobile$: Observable<boolean>;
  btnSize$: Observable<"sm" | "md">;

  constructor(private breakpointObserver: BreakpointObserver, private elementRef: ElementRef) {
    this.isMobile$ = this.breakpointObserver.observe([Breakpoints.Handset]).pipe(
      map((result) => {
        const element = this.elementRef.nativeElement;
        if (element.classList.contains("force-mobile")) {
          return true;
        }
        if (element.classList.contains("force-desktop")) {
          return false;
        }
        return result.matches;
      })
    );

    this.btnSize$ = this.isMobile$.pipe(map((isMobile) => (isMobile ? this.sizeMap.mobile : this.sizeMap.desktop)));
  }

  onButtonClick(): void {
    this.onClick.emit();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
